import { render, staticRenderFns } from "./matricula-registro.vue?vue&type=template&id=3d9b2813&"
import script from "./matricula-registro.component.ts?vue&type=script&lang=ts&"
export * from "./matricula-registro.component.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports